export const useImagesLoaded = (selector: string) => {
  const images = document.querySelectorAll(selector)
  const loadPromises = Array.from(images).map((image: any) => {
    if (image.complete) {
      return Promise.resolve()
    } else {
      return new Promise(resolve => {
        image.addEventListener('load', resolve)
        image.addEventListener('error', resolve)
      })
    }
  })
  return Promise.all(loadPromises)
}
